import { useAppDispatch } from '@/store/hooks';
import { closeDialog } from '@fuse/core/FuseDialog/fuseDialogSlice';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon';
import { DialogTitle, IconButton } from '@mui/material';
import HelpTooltip from '../HelpTooltip';

/**
 * This is a predefined component that is used to render out a header for a modal.
 * It contains the title of the modal and a close button.
 */
function ModalHeader({ title, onCancel, help }: { title: string, onCancel?: () => void, help?: string }) {

    const dispatch = useAppDispatch();

    return <DialogTitle
        className='flex items-center justify-between w-full'
    >
        <span className='flex'>{title}{help && <HelpTooltip content={help} />}</span>
        <IconButton
            onClick={() => {
                if (onCancel) {
                    onCancel();
                } else {
                    dispatch(closeDialog());
                }
            }}
            color="error"
            className='bg-red-500/20 hover:bg-red-500/30'
        >
            <FuseSvgIcon
                size={15}
                className="arrow-icon"
            >
                heroicons-outline:x-mark
            </FuseSvgIcon>
        </IconButton>
    </DialogTitle>;

}

export default ModalHeader;
